import './Sidebar.css';

function Sidebar({ currentPage, onPageChange }) {
  const pages = [
    { id: 'leaderboard', label: 'Leads Board', icon: '📊' },
    { id: 'prospects', label: 'Targets', icon: '⭐' },
    { id: 'clients', label: 'Clients', icon: '👥' },
  ];

  return (
    <aside className="sidebar">
      <nav className="sidebar-nav">
        {pages.map((page) => (
          <button
            key={page.id}
            className={`nav-item ${currentPage === page.id ? 'active' : ''}`}
            onClick={() => onPageChange(page.id)}
          >
            <span className="nav-icon">{page.icon}</span>
            <span className="nav-label">{page.label}</span>
          </button>
        ))}
      </nav>
    </aside>
  );
}

export default Sidebar;
